
import { ManhuntMapPoi } from "@/models/MapPois/ManHunt/ManhuntMapPoi";
import { cloneDeep, isEqual, toArray } from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import PoiFxTable from "../Tables/PoiFxTable.vue";

@Component({
  components: { PoiFxTable },
})
class PoiFx extends Vue {
  @Prop({ default: null }) readonly mapPoi!: ManhuntMapPoi;
  @Prop({ default: false }) readonly isSavedOrDiscard!: boolean;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  showSavePanel = false;
  mapPoiClone = {} as ManhuntMapPoi;

  created(): void {
    this.mapPoiClone = cloneDeep(this.mapPoi);
  }
  updateTempObject(challengeData: any): void {
    this.mapPoiClone = challengeData;
    if (!isEqual(this.mapPoi, this.mapPoiClone)) {
      this.showSavePanel = true;
    } else {
      this.showSavePanel = false;
    }
    this.$emit("updateTempObject", this.mapPoiClone);
  }

  @Watch("isSavedOrDiscard")
  onisSaveOrDiscardChanged(value: boolean): void {
    if (value) {
      this.showSavePanel = false;
    }
  }

  @Watch("mapPoi")
  onContentChange(value: ManhuntMapPoi): void {
    this.mapPoiClone = cloneDeep(value);
  }
}

export default PoiFx;
